module.exports = __webpack_public_path__ + "img/dates.7f6290e6.png";